import { lightSuccess, lightWarning } from 'src/colors';
import { EmployeeInvitationStatus } from 'src/features/employees/types/enum/employee-invitation-status';

export const invitationStateTranslations = {
  [EmployeeInvitationStatus.COMPLETED]:
    'employees:employees.inviteStatus.accepted' as const,
  [EmployeeInvitationStatus.INVITED]:
    'employees:employees.inviteStatus.pending' as const,
};

export const invitationStateColor = {
  [EmployeeInvitationStatus.INVITED]: lightWarning.light,
  [EmployeeInvitationStatus.COMPLETED]: lightSuccess.dark,
};
